export const FavIcons = () => {
  return (
    <>
      <link
        href={`${process.env.NEXT_PUBLIC_BASE_URL}/assets/img/device/apple-icon-57x57.png`}
        rel="apple-touch-icon"
        sizes="57x57"
      />
      <link
        href={`${process.env.NEXT_PUBLIC_BASE_URL}/assets/img/device/apple-icon-60x60.png`}
        rel="apple-touch-icon"
        sizes="60x60"
      />
      <link
        href={`${process.env.NEXT_PUBLIC_BASE_URL}/assets/img/device/apple-icon-72x72.png`}
        rel="apple-touch-icon"
        sizes="72x72"
      />
      <link
        href={`${process.env.NEXT_PUBLIC_BASE_URL}/assets/img/device/apple-icon-76x76.png`}
        rel="apple-touch-icon"
        sizes="76x76"
      />
      <link
        href={`${process.env.NEXT_PUBLIC_BASE_URL}/assets/img/device/apple-icon-114x114.png`}
        rel="apple-touch-icon"
        sizes="114x114"
      />
      <link
        href={`${process.env.NEXT_PUBLIC_BASE_URL}/assets/img/device/apple-icon-120x120.png`}
        rel="apple-touch-icon"
        sizes="120x120"
      />
      <link
        href={`${process.env.NEXT_PUBLIC_BASE_URL}/assets/img/device/apple-icon-144x144.png`}
        rel="apple-touch-icon"
        sizes="144x144"
      />
      <link
        href={`${process.env.NEXT_PUBLIC_BASE_URL}/assets/img/device/apple-icon-152x152.png`}
        rel="apple-touch-icon"
        sizes="152x152"
      />
      <link
        href={`${process.env.NEXT_PUBLIC_BASE_URL}/assets/img/device/apple-icon-180x180.png`}
        rel="apple-touch-icon"
        sizes="180x180"
      />
      <link
        href={`${process.env.NEXT_PUBLIC_BASE_URL}/assets/img/device/android-icon-192x192.png`}
        rel="icon"
        sizes="192x192"
        type="image/png"
      />
      <link
        href={`${process.env.NEXT_PUBLIC_BASE_URL}/assets/img/device/favicon-32x32.png`}
        rel="icon"
        sizes="32x32"
        type="image/png"
      />
      <link
        href={`${process.env.NEXT_PUBLIC_BASE_URL}/assets/img/device/favicon-96x96.png`}
        rel="icon"
        sizes="96x96"
        type="image/png"
      />
      <link
        href={`${process.env.NEXT_PUBLIC_BASE_URL}/assets/img/device/favicon-16x16.png`}
        rel="icon"
        sizes="16x16"
        type="image/png"
      />
    </>
  );
};
